"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTopAreaBanner = exports.topAreaBannerContext = exports.TopAreaBannerProvider = void 0;
var _auth = require("@ori/auth");
var _featureToggles = require("@ori/feature-toggles");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _utils = require("../../components/TopAreaBanner/utils");
var _constants = require("../../constants");
var _useCookieStoreInfo = require("../../hooks/useCookieStoreInfo");
var _useGetTopAreaBanners = require("../../hooks/useGetTopAreaBanners");
var _consultantContext = require("../consultantContext");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const defaultTopAreaBannerContextValue = {
  bannersData: undefined,
  isAnonymousWithStore: false,
  isOrderOnBehalfVisible: false,
  loading: true,
  orderOnBehalfData: undefined,
  visible: false
};
const topAreaBannerContext = exports.topAreaBannerContext = /*#__PURE__*/(0, _react.createContext)(defaultTopAreaBannerContextValue);
const {
  Provider
} = topAreaBannerContext;
const TopAreaBannerProvider = ({
  children
}) => {
  const {
    owner: store
  } = (0, _useCookieStoreInfo.useCookieStoreInfo)();
  const {
    loadingVipAccess,
    vipAccess: orderOnBehalfData
  } = (0, _consultantContext.useConsultant)();
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const isAnonymousWithStore = (0, _react.useMemo)(() => isAnonymousUser && !!store, [isAnonymousUser, store]);
  const enableTopAreaBanner = isFeatureEnabled(_constants.TopAreaFeature.EnableTopAreaBanner);
  const shouldGetBannerType = !(0, _presentationUtils.isSSR)() && enableTopAreaBanner;
  const bannerType = (0, _react.useMemo)(() => shouldGetBannerType ? (0, _utils.getTopAreaBannerType)(window.location.pathname) : null, [shouldGetBannerType]);
  /**
   * VipAccessData can be defined but can arrive with empty key properties.
   */
  const orderOnBehalfVisible = (0, _react.useMemo)(() => (0, _utils2.isOrderOnBehalfVisible)(orderOnBehalfData), [orderOnBehalfData]);
  const {
    bannersData,
    loading: isLoadingTopBanner
  } = (0, _useGetTopAreaBanners.useGetTopAreaBanners)({
    bannerType,
    orderOnBehalfVisible
  });
  const topBannerVisible = (0, _react.useMemo)(() => (0, _utils2.isTopAreaBannerVisible)(bannersData), [bannersData]);
  const visible = orderOnBehalfVisible || Boolean(enableTopAreaBanner);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: (0, _react.useMemo)(() => ({
      bannersData,
      isAnonymousWithStore,
      isOrderOnBehalfVisible: orderOnBehalfVisible,
      loading: (0, _utils2.isLoading)({
        isLoadingTopBanner,
        topBannerVisible,
        isAnonymousWithStore,
        loadingVipAccess,
        orderOnBehalfVisible
      }),
      orderOnBehalfData,
      visible
    }), [bannersData, isAnonymousWithStore, isLoadingTopBanner, loadingVipAccess, orderOnBehalfData, orderOnBehalfVisible, topBannerVisible, visible]),
    children: children
  });
};
exports.TopAreaBannerProvider = TopAreaBannerProvider;
const useTopAreaBanner = () => (0, _react.useContext)(topAreaBannerContext);
exports.useTopAreaBanner = useTopAreaBanner;
